var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col sm:w-1/1 w-full mb-base"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"By Coa"}},[_c('div',{staticClass:"tab-text"},[_c('index-by-coa')],1)]),_c('vs-tab',{attrs:{"label":"By Detail COA"}},[_c('div',{staticClass:"tab-text"},[_c('index-by-trx')],1)])],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }